<app-view-title Title="{{ 'Intellitrailer.Rental.ReturnComplete.Headline' | translate : 'Return complete!' }}" [isPrimaryColor]="true"></app-view-title>
<view-content [centered]="true">
  @if(!loading) {
  <ng-container>
    <app-information-screen [centered]="true" [secondaryColor]="true"
                            primaryContent="{{ primaryContent }}"
                            image="/assets/Images/big-checkbox-white.png"
                            [showInvite]="hasActiveCampaign" [discounts]="discount">


    </app-information-screen>
  </ng-container>
  }
  @else if (loading) {
  <div class="spinner-container">
    <mat-spinner diameter="70" mode="indeterminate" class="inverted-spinner"></mat-spinner>
    <p>{{ 'Intellitrailer.Rental.ReturnComplete.LoadingReturn' | translate : 'Loading...' }}</p>
  </div>
  }
</view-content>
<view-actions >
  @if(!loading) {
  <button mat-raised-button color="accent" (click)="confirm()">{{ 'Intellitrailer.Rental.ReturnComplete.cmdConfirm' | translate : 'OK' }}</button>
  }
</view-actions>

